<template>
  <div>
    <div class="mask" v-if="isShow" @click="hideDetails()">

    </div>
    <div class="guestDetails" v-if="isShow">
      <div class="window-head"><a href="javascript:void(0)" class="icon-close" @click="hideDetails()"></a></div>
      <div class="window-body">
        <div class="guest-info">
          <div>
            <img v-if="details.imageMapId" :src="'//s2-content.smarket.net.cn/index.php?mappingId='+details.imageMapId" alt=""/>
            <img v-else src="../assets/guest-null.jpg" alt=""/>
          </div>
          <div>
            <p class="guest-name">{{details.name}}</p>
            <p>
              <span v-html="details.enterprise"></span><br/>
              <span>{{details.duty}}</span>
            </p>
          </div>
        </div>
        <div class="guest-introduce">
          <p v-if="details.intro" v-html="details.intro"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GuestDetails',
  props: ['_isShow','details'],
  data: function() {
    return {};
  },
  computed: {
    isShow() {
      return this._isShow || false;
    }
  },
  methods: {
    hideDetails() {
      this.$emit('hideDetails');
    }
  }
};
</script>

<style scoped lang="scss">
.guestDetails{
  position: absolute;
  top: 0;
  left: -490px;
  width: 480px;
  z-index: 10010;
  background-color: rgb(255, 255, 255);
  font-size: 16px;
  line-height: 16px;
  color: rgb(38, 38, 38);
  box-shadow: rgba(212, 215, 222, 0.57) 0 2px 0.03rem 0;
  padding: 10px 10px 20px 20px;
  .icon-close {
    display: inline-block;
    width: 27px;
    height: 27px;
    background: url("../assets/close-black.png") no-repeat center/cover;
    float: right;
  }
  .guest-info{
    display:flex;
    align-items: center;
    div:first-child{
      width: 92px;
      height: 92px;
      border-radius: 50%;
      flex: none;
      overflow: hidden;
      img{
        width:100%;
        height:auto;
      }
    }
    >div:last-child{
      margin-left:25px;
      .guest-name{
        font-size: 16px;
        line-height: 20px;
        font-weight: bold;
        //margin: 0;
        &+p{
          font-size: 14px;
        }
      }
    }
  }
  .guest-introduce{
    margin-top:1px;
    overflow: auto;
    word-break: break-all;
    p{
      margin: 5px 0;
      font-size: 14px;
    }
  }
  .more{
    color: #137ae9;
    text-align: center;
    display: block;
  }
  .guest-more{
    overflow: auto;
    height:320px;
  }
}
.mask{
  display: none;
}

@media screen and (max-width: 750px) {
  .mask{
    display: block;
    position: fixed;
    left:0;
    top:0;
    background: rgba(0,0,0,0.4);
    width:100%;
    height: 100%;
    z-index: 10000;
  }
  .guestDetails{
    position: absolute;
    top: 0;
    left: 0;
    width: pxToRem(630);
    font-size: pxToRem(18);
    line-height: pxToRem(32);
    padding: pxToRem(10) pxToRem(20) pxToRem(20) pxToRem(20);
    box-sizing: border-box;
    .icon-close {
      width: pxToRem(27);
      height: pxToRem(27);
    }
    .guest-info{
      div:first-child{
        width: pxToRem(135);
        height: pxToRem(135);
      }
      >div:last-child{
        margin-left:pxToRem(25);
        .guest-name{
          font-size: pxToRem(16);
          line-height: pxToRem(20);
          &+p{
            font-size: pxToRem(14);
          }
        }
      }
    }
    .guest-introduce{
      margin-top:1px;
      overflow: auto;
      word-break: break-all;
      p{
        margin: pxToRem(5) 0;
        font-size: pxToRem(14);
      }
    }
    .more{
      color: #137ae9;
      text-align: center;
      display: block;
    }
    .guest-more{
      height:pxToRem(320);
    }
  }
}
</style>